import { render } from "./SubTaskComponent.vue?vue&type=template&id=8b27d91e&scoped=true"
import script from "./SubTaskComponent.vue?vue&type=script&lang=js"
export * from "./SubTaskComponent.vue?vue&type=script&lang=js"

import "./SubTaskComponent.vue?vue&type=style&index=0&id=8b27d91e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b27d91e"]])

export default __exports__